export const trim = (string: string) => {
    return String(string).trim();
}